/**
 * placeApi.js
 * -----------
 * API client for Place Master (Place) using createMasterApiClient.
 * Connects directly to FastAPI backend /place/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const placeClient = createMasterApiClient('place');

export const listPlaces = (params) => placeClient.list(params);
export const getPlaceDetail = (id) => placeClient.getById(id);
export const createPlace = (data) => placeClient.create(data);
export const updatePlace = (id, data) => placeClient.update(id, data);
export const archivePlace = (id) => placeClient.archive(id);
export const deletePlace = (id) => placeClient.remove(id);
export const getPlaceOptions = () => placeClient.getDropdownOptions();
